export default (...args) => {
  if (typeof window !== 'undefined') {
    try {
      window.ga(...args);
    } catch (err) {
      console.log(err, 'Error: No tracking');
    }
  }
}